module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar renderHtmlWrapper = config && config.renderHtmlWrapper;\nvar title;\nvar subTitle;\nvar message;\nvar image = {};\nvar fallbackImageUrl = '/images/error.jpg';\nvar statusCode = 500;\nvar errorType = 'fallback';\nif(resourceData && resourceData.statusCode) statusCode = resourceData.statusCode;\n// estimate right error type\nif(statusCode == 404) errorType = 'notFound';\nelse if(statusCode == 'clientError') errorType = 'clientError';\n// isClient\nif(typeof(model) !== 'undefined'){\nswitch(errorType){\ncase 'notFound':\ntitle       = model.title_404;\nsubTitle    = model.subTitle_404;\nmessage     = model.message_404;\nimage       = (helpers.detectRenderedImage(model.image_404, model._image_404) || {}).rendered || {};\nbreak;\ncase 'clientError':\ntitle       = model.title_client;\nsubTitle    = model.subTitle_client;\nmessage     = model.message_client;\nimage       = (helpers.detectRenderedImage(model.image_client, model._image_client) || {}).rendered || {};\nbreak;\ncase 'fallback':\ndefault:\ntitle       = model.title;\nsubTitle    = model.subTitle;\nmessage     = model.message;\nimage       = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\nbreak;\n}\n}\n// isServer || Fallback\nelse {\nif(!title)      title       = __('error:' + errorType + '.title');\nif(!subTitle)   subTitle    = __('error:' + errorType + '.subTitle');\nif(!message)    message     = '<p>' + __('error:' + errorType + '.message') + '</p>';\n}\nif(renderHtmlWrapper){\n%>\n<html>\n<head>\n<title><%= title %></title>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css\" />\n</head>\n<body class=\"error_container\">\n<%\n}\n%>\n<div class=\"errors_errors\">\n<div class=\"image\" style=\"background-image: url(<%- image.url || fallbackImageUrl %>);\"></div>\n<div class=\"content\">\n<h1><%= title %></h1>\n<h2><%= subTitle %></h2>\n<%- message %>\n</div>\n</div>\n<%\nif(renderHtmlWrapper){\n%>\n</body>\n</html>\n<%\n}\n%>"
  , __filename = "components/errors/errors.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var renderHtmlWrapper = config && config.renderHtmlWrapper;
var title;
var subTitle;
var message;
var image = {};
var fallbackImageUrl = '/images/error.jpg';
var statusCode = 500;
var errorType = 'fallback';
if(resourceData && resourceData.statusCode) statusCode = resourceData.statusCode;
// estimate right error type
if(statusCode == 404) errorType = 'notFound';
else if(statusCode == 'clientError') errorType = 'clientError';
// isClient
if(typeof(model) !== 'undefined'){
switch(errorType){
case 'notFound':
title       = model.title_404;
subTitle    = model.subTitle_404;
message     = model.message_404;
image       = (helpers.detectRenderedImage(model.image_404, model._image_404) || {}).rendered || {};
break;
case 'clientError':
title       = model.title_client;
subTitle    = model.subTitle_client;
message     = model.message_client;
image       = (helpers.detectRenderedImage(model.image_client, model._image_client) || {}).rendered || {};
break;
case 'fallback':
default:
title       = model.title;
subTitle    = model.subTitle;
message     = model.message;
image       = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};
break;
}
}
// isServer || Fallback
else {
if(!title)      title       = __('error:' + errorType + '.title');
if(!subTitle)   subTitle    = __('error:' + errorType + '.subTitle');
if(!message)    message     = '<p>' + __('error:' + errorType + '.message') + '</p>';
}
if(renderHtmlWrapper){

    ; __line = 45
    ; __append("\n<html>\n<head>\n<title>")
    ; __line = 48
    ; __append(escapeFn( title ))
    ; __append("</title>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css\" />\n</head>\n<body class=\"error_container\">\n")
    ; __line = 52
    ; 
}

    ; __line = 54
    ; __append("\n<div class=\"errors_errors\">\n<div class=\"image\" style=\"background-image: url(")
    ; __line = 56
    ; __append( image.url || fallbackImageUrl )
    ; __append(");\"></div>\n<div class=\"content\">\n<h1>")
    ; __line = 58
    ; __append(escapeFn( title ))
    ; __append("</h1>\n<h2>")
    ; __line = 59
    ; __append(escapeFn( subTitle ))
    ; __append("</h2>\n")
    ; __line = 60
    ; __append( message )
    ; __append("\n</div>\n</div>\n")
    ; __line = 63
    ; 
if(renderHtmlWrapper){

    ; __line = 65
    ; __append("\n</body>\n</html>\n")
    ; __line = 68
    ; 
}

    ; __line = 70
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/errors/errors.ejs

}